var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.949.635l1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L2.049.635l4.95 4.95z",
    fill: "#006EAD",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iIzAwNkVBRCI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTExLjk0OSAwLjYzNUwxMy4zNjMgMi4wNDkgOC40MTMgNi45OTkgMTMuMzYzIDExLjk0OSAxMS45NDkgMTMuMzYzIDYuOTk5IDguNDEzIDIuMDQ5IDEzLjM2MyAwLjYzNSAxMS45NDkgNS41ODUgNi45OTkgMC42MzUgMi4wNDkgMi4wNDkgMC42MzUgNi45OTkgNS41ODV6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTUgLTE1KSB0cmFuc2xhdGUoMTUgMTUpIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgIconClose as ReactComponent };